module.exports = global["jQuery"] = require("-!F:\\qsujuan\\wwwroottwo\\r瑞朗\\ruilang\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");